import React, { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import RoutesToPages from "../../RoutesToPages";

const FooterLinks = forwardRef((props, ref) => {
  const navigate = useNavigate();

  const footerRedirect = (target) => {
    navigate(target);
  };

  return (
    <div className="terms__wrapper">
      <div
        className="terms__link"
        onClick={() => footerRedirect(RoutesToPages.myAccount)}
      >
        My account
      </div>
      <div className="divider">|</div>
      <div
        className="terms__link"
        onClick={() => footerRedirect(RoutesToPages.terms)}
      >
        Terms and Conditions
      </div>
      <div className="divider">|</div>
      <div
        className="terms__link"
        onClick={() => footerRedirect(RoutesToPages.policy)}
      >
        Privacy policy
      </div>
    </div>
  );
});

export default FooterLinks;
